<script setup lang="ts">
</script>

<template>
  <div>
    <div class="content-container">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
//@use "@/assets/styles/shared/screen" as screen;

.content-container {
  width: 100%;
  max-width: 144rem;
  margin: 0 auto;
  padding: 0 var(--spacing-m);

  // @include screen.respond(desktop) {
  //   max-width: 124rem;
  // }
  // @include screen.respond(tablet) {
  //   max-width: 77.4rem;
  // }
  // @include screen.respond(mobile) {
  //   max-width: 100%;
  // }
}
</style>
